import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import PublicRoute from "../protectedRoute/publicRoute";
import { store } from '../redux/store';
import MainLandingPage from "../pages/mainLandingPage";
import ProjectRoutes from "./projectRoutes";
import Cookies from "js-cookie";
import NotFound from "../common/notfound";
import setAuthToken from "../utils/setAuthToken";
import authActions from "../redux/auth/actions";
import AdminRoutes from "./adminRoutes";
import { preferenceReportAllowedUsers, searchCandidateAllowedUsers } from "../utils/constants";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import CandidateVerification from "../pages/candidateVerification";
import RollNumber from "../pages/RollNumber";

// Default project slug used when a page is reached at the site root without a
// project segment (e.g. the admit-card QR at /candidate-verification), so the
// existing project-scoped login/PrivateRoute flow can resolve. Matches the
// primary project path in mainLandingPage.
const DEFAULT_PROJECT = 'mhcet';

if (Cookies.get('mhet_mst_token')) {
  setAuthToken(Cookies.get('mhet_mst_token'));
  store.dispatch({ type: authActions.BACKOFFICE_TOKEN_VERIFY });
};

if (Cookies.get('mhet_mst_temptoken')) {
  store.dispatch({ type: authActions.BACKOFFICE_TOKEN_VERIFY });
};

// The candidate verification QR is served at the site root (no project segment).
// Ensure a project is set so the existing auth/login flow can redirect correctly,
// then reuse the standard PrivateRoute guard.
const CandidateVerificationEntry = () => {
  if (!Cookies.get('mhet_mst_project')) {
    Cookies.set('mhet_mst_project', DEFAULT_PROJECT, { expires: 7 });
    // AppRoutes built the project routes before this cookie existed (first
    // visit, e.g. a verifier's first QR scan), so the login redirect would land
    // on a blank page and lose the QR link. Reload once to rebuild the routes.
    window.location.reload();
    return null;
  }
  return (
    <PrivateRoute>
      <CandidateVerification />
    </PrivateRoute>
  );
};

const AppRoutes = () => {


  // useEffect(() => {
  //   if (Cookies.get('mhet_mst_project') && window.location.pathname === '/') {
  //     if (Cookies.get('mhet_mst_token')) {
  //       window.location.href = `${`/${Cookies.get('mhet_mst_project')}/home`}`;
  //     } else {
  //       window.location.href = `${`/${Cookies.get('mhet_mst_project')}/`}`;
  //     };
  //   };
  // }, []);

  useEffect(() => {
  const project = Cookies.get("mhet_mst_project");
  const token = Cookies.get("mhet_mst_token");
  const userId = Cookies.get("mhet_mst_userid");

  if (project && window.location.pathname === "/") {
    if (token) {
      if (preferenceReportAllowedUsers.includes(String(userId))) {
        // 🔒 Redirect to preference report
        window.location.href = `/${project}/course-wise-preference-report`;
      } else if (searchCandidateAllowedUsers.includes(String(userId))) {
        // 🔒 Redirect to search candidate
        window.location.href = `/${project}/search-candidate`;
      } else {
        // ✅ Normal users
        window.location.href = `/${project}/home`;
      }
    } else {
      window.location.href = `/${project}/`;
    }
  }
}, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<PublicRoute><MainLandingPage /></PublicRoute>} />
        <Route path="/candidate-verification" element={<CandidateVerificationEntry />} />
        {/* Reference admit-card QR. Fully public: deliberately NOT wrapped in
            PublicRoute (that sends logged-in users to their home page). */}
        <Route path="/roll-number" element={<RollNumber />} />
        <Route path="/roll-number/:rollno" element={<RollNumber />} />
        <Route path="/r/:token" element={<RollNumber />} />
        {/* <Route path="/*" element={<PublicRoute><NotFound /></PublicRoute>} /> */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path={Cookies.get('mhet_mst_project') ? `${Cookies.get('mhet_mst_project')}/*` : '/*'} element={<ProjectRoutes />} />
        <Route path="/*" element={<PublicRoute><NotFound /></PublicRoute>} />
      </Routes>
    </>
  );
};

export default AppRoutes;
